import {
  CREATE_AGENT_CONFIG,
  FETCH_AGENT_CONFIG,
  SET_GENERATED_PROMPT,
  SET_AGENT_LOADING,
  SET_AGENT_ERROR,
  DELETE_AGENT_CONFIG, // ✅ Add this
  TOGGLE_AGENT_STATUS
} from '../Actions/AI/type';

const initialState = {
  config: null,
  prompt: '',
  loading: false,
  error: null
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_AGENT_LOADING:
      return { ...state, loading: true };
    case SET_AGENT_ERROR:
      return { ...state, error: action.payload, loading: false };
    case FETCH_AGENT_CONFIG:
    case CREATE_AGENT_CONFIG:
      return { ...state, config: action.payload, loading: false };
    case SET_GENERATED_PROMPT:
      return { ...state, prompt: action.payload, loading: false };
    case DELETE_AGENT_CONFIG:
      return { ...state, config: null, prompt: '', loading: false };
    case TOGGLE_AGENT_STATUS:
      return {
        ...state,
        config: action.payload,
        loading: false
      };
    default:
      return state;
  }
}
